import React, {createContext, useContext} from "react";

const TravianServerContext = createContext<{ serverInfo: typeof SERVERINFO }>(null);

export function useTravianServerContext() {
    return useContext(TravianServerContext);
}

declare var SERVERINFO: {
    tmajor: 4|5,
    tversion: string,
    speed: number,
    url: string,
    travianFeatures: Record<string, any>
};

export function TravianServerProvider({ children }) {
    return <TravianServerContext.Provider value={{
        serverInfo: SERVERINFO
    }}>
        {children}
    </TravianServerContext.Provider>
}
